<script setup lang="ts">
import { provide, ref, watch } from 'vue'

const props = withDefaults(
    defineProps<{
        min: number
        max: number
        counter: number
    }>(),
    {
        counter: 0,
    },
)

const counter = ref(props.counter)

watch(
    () => props.counter,

    (newValue) => {
        counter.value = newValue

        if (counter.value >= props.max) {
            return (counter.value = props.max)
        }

        if (counter.value <= props.min) {
            return (counter.value = props.min)
        }
    },
)

provide<number>('min', props.min)
provide<number>('max', props.max)

defineEmits<{
    (e: 'increment'): void
    (e: 'decrement'): void
}>()
</script>

<template>
    <div class="flex items-center gap-4 tabular-nums">
        <slot />
    </div>
</template>
